module.exports = __webpack_public_path__ + "static/media/Inter-Black.bfea424a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Black.woff
// module id = 675
// module chunks = 21